export enum ProductStage {
  GAST = "",
  DTZ = "dtz",
  INL = "inl",
}
